import smartSolveApi from './instances/smartsolve';

export const uploadCustomerLogoImage = async (file) => {
  try {
    const formData = new FormData();

    formData.append('FileName', file[0].name);
    formData.append('FileDescription', '');
    formData.append('FileStream', file[0]);

    const response = await smartSolveApi.post('/customizations/client-logo', formData);

    return response.data;
  } catch (e) {
    throw new Error(`uploadCustomerLogoImage() failed: ${e}`);
  }
};

export const getCustomerLogo = async () => {
  try {
    const response = await smartSolveApi.get('/configurations/APPLICATION/CUSTOMER_LOGO/content');

    return response.data;
  } catch (e) {
    throw new Error(`getCustomerLogo() failed: ${e}`);
  }
};

export const deleteCustomerLogo = async () => {
  try {
    const response = await smartSolveApi.delete('/customizations/client-logo');

    return response.data;
  } catch (e) {
    throw new Error(`deleteCustomerLogo() failed: ${e}`);
  }
};
